import React, { useMemo } from 'react'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import { ISearchResultTypeContextExpose, SearchResultTypeContext } from '@cbgms/components/src/top-search/context/SearchResultTypeContext'

export const SearchResultTypeContextProvider: React.FC = ({ children }) => {
  const isPortal = useIsPortal()
  const searchResultContextData = useMemo<ISearchResultTypeContextExpose>(() => ({ isPortal }), [isPortal])

  return <SearchResultTypeContext.Provider value={searchResultContextData}>{children}</SearchResultTypeContext.Provider>
}
